import assestsConfig from "../../config/assestsConfig";

// const BASEURL = 'http://127.0.0.1:8000/graphql/'
// const BASEURL = 'http://94.136.187.221:8019/graphql/'

// const BASEURL = 'http://192.168.0.174:8000/graphql/'

// const BASEURL = "https://hrmsdbdemobk.keelis.in/graphql/";
// export const imgurl = "https://hrmsdbdemobk.keelis.in/media"    
// export const pdfurl = "https://hrmsdbdemobk.keelis.in/media/"


// const BASEURL = "https://hrmsdev.keelis.in/graphql/"; // development server
// export const imgurl = "https://hrmsdev.keelis.in/media"
// export const pdfurl = "https://hrmsdev.keelis.in/media/"
// const BASEURL = "http://192.168.0.136:8000/graphql/"; // dlocal server

// const BASEURL = 'https://hrms.ssiofficebk.keelis.in/graphql/'

// const BASEURL = 'http://13.234.176.236:8000/graphql/'
// const BASEURL = 'http://13.234.176.236:8000/graphql/'
// const BASEURL = "http://13.234.176.236:8000/graphql/";
// const BASEURL = 'https://hrms.ssioffices.com:2000/graphql/'
// const BASEURL = 'https://hrms.ssiofficebk.keelis.in/graphql/'


// const BASEURL = "http://hrmsdevv1.0bk.athithishala.com/graphql/";
// export const imgurl = "http://hrmsdevv1.0bk.athithishala.com/media"
// export const pdfurl = "http://hrmsdevv1.0bk.athithishala.com/media/"



// const BASEURL = "http://actebk.keelis.in/graphql/";
// export const imgurl = "http://actebk.keelis.in/media"    
// export const pdfurl = "http://actebk.keelis.in/media/"


// const BASEURL = "http://kelinbk.keelis.in/graphql/";
// export const imgurl = "http://kelinbk.keelis.in/media"    
// export const pdfurl = "http://kelinbk.keelis.in/media/"



// dev

// const BASEURL = "https://hrmsdev.keelis.in/graphql/"; // development server
// export const imgurl = "https://hrmsdev.keelis.in/media"
// export const pdfurl = "https://hrmsdev.keelis.in/media/"

const BASEURL = assestsConfig.baseurl; // development server
export const imgurl = assestsConfig.mediaurl
export const pdfurl = assestsConfig.pdfurl 

// const BASEURL = "http://hrmstestbk.athithishala.com/graphql/"; //test
// export const imgurl = "http://hrmstestbk.athithishala.com/media";
// export const pdfurl = "http://hrmstestbk.athithishala.com/media/";


// const BASEURL = "https://hrmsbk.egtech.in/graphql/"; // live server
// export const imgurl = "https://hrmsbk.egtech.in/media"
// export const pdfurl = "https://hrmsbk.egtech.in/media/"


export default BASEURL;
